module.exports = "/_next/static/images/coins-62234c5a2fdc9b59cd4e2c36fcdce7b9.svg";